import _forEach from "lodash/forEach";
import _isEmpty from "lodash/isEmpty";
import _values from "lodash/values";
import { State as CheckoutState } from "./checkout";

type State = CheckoutState;

export const getExtraDataSimPrice = (state: State) => state.checkout.member?.extraSim?.dataSimPrice;
export const getExtraTvillingSimPrice = (state: State) => state.checkout.member?.extraSim?.tvillingSimPrice;
export const isMandatoryMemberFieldsCompleted = (state: State): boolean => {
    let isCompleted = true;

    const subscriptions = _values(state.checkout.subscriptions || {});
    if (_isEmpty(subscriptions)) {
        return false;
    }

    _forEach(subscriptions, (sub) => {
        if (!isCompleted) return false; // early exit if one item of the subscription is not finished

        if (
            (!sub.phoneNumber?.check.isAllowedToProceed && sub.phoneNumber?.check.type !== "new") ||
            (sub.phoneNumber?.check.type === "new" && _isEmpty(sub.phoneNumber?.selectedPhoneNumber)) ||
            !sub.productUser
        ) {
            isCompleted = false;
        }
    });

    return isCompleted;
};
export const getHasExistingExtraDataSim = (state: State) => state.checkout.member?.extraSim?.hasExistingExtraDataSim;

export const getSelectedStep = (state: State) => state.checkout.member?.selectedStep;
